class LiteVimeoEmbed extends HTMLElement {
    static preconnected = false // eslint-disable-line

    constructor() {
      super()
      this.iframeLoaded = false
      this.setupDom()
      // this.setupComponent()
      this.initIntersectionObserver()
    }

    static get observedAttributes() {
      return ['videoid']
    }

    get videoId() {
      return encodeURIComponent(this.getAttribute('videoid') || '')
    }

    set videoId(id) {
      this.setAttribute('videoid', id)
    }

    get videoTitle() {
      return this.getAttribute('videotitle') || 'Video'
    }

    set videoTitle(title) {
      this.setAttribute('videotitle', title)
    }

    /**
     * Inject the iframe into the component body
     */
    addIframe() {
      if (!this.iframeLoaded) {
        const srcUrl = new URL(
          `/video/${this.videoId}?autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1&controls=0&dnt=1&quality=auto`,
          'https://player.vimeo.com/',
        )

        // TODO: construct src value w/ URL constructor
        const iframeHTML = `
  <iframe frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen src="${srcUrl}"></iframe>`
        this.domRefFrame.insertAdjacentHTML('beforeend', iframeHTML)
        // this.domRefFrame.classList.add('lvo-activated');
        this.iframeLoaded = true
      }
    }

    /**
     * Define our shadowDOM for the component
     */
    setupDom() {
      const shadowDom = this.attachShadow({ mode: 'open' })
      shadowDom.innerHTML = `
            <style>
              :host {
                contain: content;
                display: block;
                position: absolute;
                inset: 0;
                pointer-events: none;
                --container-width: 0;
                --container-height: 0;
              }

              #frame {
                position: absolute;
                inset: 0;
              }

              iframe {
                --height-width-ratio: (var(--video-height) / var(--video-width));
                --width-height-ratio: (var(--video-width) / var(--video-height));

                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: var(--container-width);
                height: calc(var(--container-width) * var(--height-width-ratio));
                min-height: var(--container-height);
                min-width: calc(var(--container-height) * var(--width-height-ratio));
                pointer-events: none;
              }
            </style>
            <div id="frame">
            </div>
          `
      this.domRefFrame = this.shadowRoot.querySelector('#frame')
      this.computeRootSize()
      window.addEventListener('resize', () => this.computeRootSize())
      window.addEventListener('menu:open', () => this.computeRootSize())
    }

    computeRootSize() {
      const root = this.shadowRoot.host
      const rootWidth = root.offsetWidth
      const rootHeight = root.offsetHeight
      this.domRefFrame.style.setProperty('--container-width', `${rootWidth}px`)
      this.domRefFrame.style.setProperty('--container-height', `${rootHeight}px`)
      // console.log('root size', rootWidth, rootHeight)
    }

    /**
     * Parse our attributes and fire up some placeholders
     */
    // setupComponent() {
    //   this.setAttribute('title', `${this.videoPlay}: ${this.videoTitle}`)
    // }

    /**
     * Setup the Intersection Observer to load the iframe when scrolled into view
     */
    initIntersectionObserver() {
      if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        }

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.iframeLoaded) {
              LiteVimeoEmbed.warmConnections()
              this.addIframe()
              obs.unobserve(this)
            }
          })
        }, options)

        observer.observe(this)
      }
    }

    /**
     * Add a <link rel={preload | preconnect} ...> to the head
     * @param {*} kind
     * @param {*} url
     * @param {*} as
     */
    static addPrefetch(kind, url, as) {
      const linkElem = document.createElement('link')
      linkElem.rel = kind
      linkElem.href = url
      if (as) {
        linkElem.as = as
      }
      linkElem.crossOrigin = 'true'
      document.head.append(linkElem)

      // console.log('add prefetch')
    }

    /**
     * Begin preconnecting to warm up the iframe load Since the embed's netwok
     * requests load within its iframe, preload/prefetch'ing them outside the
     * iframe will only cause double-downloads. So, the best we can do is warm up
     * a few connections to origins that are in the critical path.
     *
     * Maybe `<link rel=preload as=document>` would work, but it's unsupported:
     * http://crbug.com/593267 But TBH, I don't think it'll happen soon with Site
     * Isolation and split caches adding serious complexity.
     */
    static warmConnections() {
      if (LiteVimeoEmbed.preconnected) return

      // Host that Vimeo uses to serve JS needed by player
      LiteVimeoEmbed.addPrefetch('preconnect', 'https://f.vimeocdn.com')

      // The iframe document comes from player.vimeo.com
      LiteVimeoEmbed.addPrefetch('preconnect', 'https://player.vimeo.com')

      // Image for placeholder comes from i.vimeocdn.com
      // LiteVimeoEmbed.addPrefetch('preconnect', 'https://i.vimeocdn.com')

      LiteVimeoEmbed.preconnected = true
    }
  }

  customElements.define('lite-vimeo', LiteVimeoEmbed)